import React from "react";
import { cn } from "@/lib/utils";

const STATUS_STYLES = {
  HIJAU: "bg-emerald-50 text-emerald-700 border-emerald-200",
  KUNING: "bg-amber-50 text-amber-700 border-amber-200",
  MERAH: "bg-rose-50 text-rose-700 border-rose-200",
};

const STATUS_DOT = {
  HIJAU: "bg-emerald-500",
  KUNING: "bg-amber-500",
  MERAH: "bg-rose-500",
};

export function StatusBadge({ status, className, showDot = true, ...props }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.KUNING;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold tracking-wide font-heading",
        s,
        className
      )}
      data-testid={`status-badge-${status}`}
      {...props}
    >
      {showDot && (
        <span className={cn("h-1.5 w-1.5 rounded-full", STATUS_DOT[status] || STATUS_DOT.KUNING)} />
      )}
      {status}
    </span>
  );
}

export function statusColorClasses(status) {
  return STATUS_STYLES[status] || STATUS_STYLES.KUNING;
}
